import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/font-package',
  component: Layout,
  name: 'FontPackageRoot',
  meta: {
    title: '字体包管理',
    icon: 'i-ant-design:font-size-outlined',
    order: 5,
  },
  children: [
    {
      path: '',
      name: 'FontPackage',
      component: () => import('@/views/config/font-package/index.vue'),
      meta: {
        title: '字体包管理',
        icon: 'i-ant-design:font-size-outlined',
        auth: 'config:font-package:list',
        menu: false,
      },
    },
  ],
}

export default routes
